import React, { useState, useEffect, useRef } from "react";
import { SquarePen } from "lucide-react";

const ACTIVITY_STATUSES = [
  "Prep for Interview",
  "Send Thank You",
  "Send Availability",
  "Apply",
  "Follow Up",
  "Prep Cover Letter",
  "Prep Resume",
  "Reach Out",
  "Phone Screen",
  "Phone Interview",
  "On Site Interview",
  "Offer Received",
  "Accept Offer",
  "Decline Offer",
  "Rejected",
  "Email",
  "Meeting",
  "Phone Call",
  "Get Reference",
  "Assignment",
  "Networking Event",
  "Other",
  "Application Withdrawn",
];

type StatusDropdownProps = {
  value: string;
  onChange: (status: string) => void;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
};

export default function StatusDropdown({ value, onChange, open, onToggle, onClose }: StatusDropdownProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, onClose]);

  const handleSelect = (status: string) => {
    onChange(status);
  };

  return (
    <div className="status-dropdown" ref={dropdownRef}>
      <button
        className="btn small"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        type="button"
      >
        <SquarePen size={14} style={{ marginRight: 6 }} />
        {value}
      </button>

      {open && (
        <div className="status-dropdown-menu">
          {ACTIVITY_STATUSES.map((status) => (
            <div
              key={status}
              className={`status-dropdown-item ${value === status ? 'active' : ''}`}
              onClick={() => handleSelect(status)}
            >
              {status}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

